import { Injectable } from '@angular/core';

import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class FibreReferenceService extends BaseReferenceService {
  constructor() {
    super('FibreReference');
  }
}
